import React from 'react';
import classNames from 'classnames';

import { makeStyles, useTheme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

import useBackgroundColor from 'Hooks/useBackgroundColor';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import MissionControlWidget from 'Components/AdvisorApp/Viewport/MissionControl/Dashboard/Widget';
import SnapshotBalanceSheet from 'Components/UI/Snapshot/BalanceSheet';
import BalanceSheetTableContainer from 'Components/UI/BalanceSheetTable/Container';
import ChartsContainer from 'Components/UI/Snapshot/Holdings/ChartsContainer';
import NotesActionItemsContainer from './NotesActionItems';
import NotesGoalsAndInterests from './NotesGoalsAndInterests';

const useStyles = makeStyles(theme => ({
  root: {
    margin: 'auto',
    maxWidth: theme.dimensions.xxxl,
  },
  missionControl: {
    marginBottom: theme.spacing(2.5),
  },
  row: {
    display: 'flex',
    justifyContent: 'space-evenly',
  },
  rowItem: {
    padding: theme.spacing(1.5),
    marginBottom: theme.spacing(2.5),
    width: '100%',
  },
  rowItemMargin: {
    marginRight: theme.spacing(2.5),
  },
  dashboardCard: {
    padding: theme.spacing(1.5),
    marginBottom: theme.spacing(2.5),
  },
}));

const LandingPageDashboard = () => {
  const classes = useStyles();
  const theme = useTheme();

  useBackgroundColor(theme.palette.facet.lightGray);
  const { householdResource } = useSimpleHousehold();

  const holdingsFeatureToggle = householdResource?.relationship('holdings');

  const holdingsRowComponents = [
    holdingsFeatureToggle && <SnapshotBalanceSheet />,
    holdingsFeatureToggle && <ChartsContainer />,
  ].filter(v => !!v);

  const bottomRowComponents = [
    <NotesActionItemsContainer />,
    <BalanceSheetTableContainer />,
  ].filter(v => !!v);

  return (
    <div className={classes.root}>
      {householdResource && (
        <MissionControlWidget
          className={classes.missionControl}
          householdResource={householdResource}
        />
      )}
      <NotesGoalsAndInterests />
      <div className={classes.row}>
        {holdingsRowComponents.map((component, i) => (
          <Paper
            key={`holdings-row-item.${i}`} // eslint-disable-line react/no-array-index-key
            className={classNames(classes.rowItem, {
              [classes.rowItemMargin]: i < holdingsRowComponents.length - 1,
            })}
            elevation={1}
          >
            {component}
          </Paper>
        ))}
      </div>
      <div className={classes.row}>
        {bottomRowComponents.map((component, i) => (
          <Paper
            key={`bottom-row-item.${i}`} // eslint-disable-line react/no-array-index-key
            className={classNames(classes.rowItem, {
              [classes.rowItemMargin]: i < bottomRowComponents.length - 1,
            })}
            elevation={1}
          >
            {component}
          </Paper>
        ))}
      </div>
    </div>
  );
};

export default LandingPageDashboard;
